import React from "react";

import s from "./Button.module.css";

const SIZES = {
	small: { fontSize: 10, height: 36, borderRadius: 36, paddingInline: 16 },
	medium: { fontSize: 12, height: 42, borderRadius: 42, paddingInline: 20 },
	large: { fontSize: 14, height: 50, borderRadius: 50, paddingInline: 24 },
};

export function ButtonV2({
	children,
	width = 118,
	size = "medium",
	color = "#fff",
	...props
}: {
	width?: React.CSSProperties["width"];
	children: React.ReactNode;
	size?: "small" | "medium" | "large";
	color?: React.CSSProperties["color"];
	[key: string]: any;
}) {
	return (
		<div>
			<button className={s.btn} style={{ width, ...SIZES[size] }} {...props}>
				<svg
					width={width}
					height={SIZES[size].height}
					viewBox="0 0 118 42"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect x="1" y="1" width="116" height="40" rx="20" stroke="#404040" strokeWidth="1" />
				</svg>
				<span style={{ color, fontSize: SIZES[size].fontSize }}>{children}</span>
			</button>
		</div>
	);
}
